import type { CarImage } from "@interfaces/gallery";
import { ImageCard } from "@components/molecules/ImageCard/ImageCard";
import styles from "./DesktopGrid.module.scss";
import { computeDesktopGridLayout } from "@helpers/image-grid-helper";

interface DesktopGridProps {
  displayedImages: CarImage[];
  handleImageClick: (variantId: string) => void;
  initialVariantsCount: number;
}

export const DesktopGrid = ({
  displayedImages,
  handleImageClick,
  initialVariantsCount,
}: DesktopGridProps) => {
  const mainImages = displayedImages.slice(0, 6);
  const remainingImages = displayedImages.slice(6);

  const renderImageGrid = (images: CarImage[]) => {
    const { imagesPerRow, imageChunks } = computeDesktopGridLayout(images);

    return (
      <div className={styles["desktop-grid__container"]}>
        {imageChunks.map((chunk, chunkIndex) => (
          <div
            key={chunkIndex}
            className={`${styles["desktop-grid__chunk"]} ${
              imagesPerRow[chunkIndex] === 1
                ? styles["desktop-grid__chunk--single"]
                : styles["desktop-grid__chunk--multiple"]
            }`}
          >
            {chunk.map((image, idx) => (
              <ImageCard
                key={image.variant_Id}
                image={image}
                onClick={handleImageClick}
                showVariantCount={
                  images === mainImages && chunkIndex === 0 && idx === 0
                }
                variantCount={initialVariantsCount}
                priority
              />
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {renderImageGrid(mainImages)}
      {remainingImages.length > 0 && (
        <div className={styles["desktop-grid__remaining"]}>
          {renderImageGrid(remainingImages)}
        </div>
      )}
    </>
  );
};
